export const WeekInput = (props) => {
  const { name, value, onChange } = props;

  /**
   * get int from bools array
   * @param {*} items
   * @returns
   */
  const getIntFromBools = (items) => {
    let out = 0;
    items.forEach((el, idx) => {
      if (el) {
        out += Math.pow(2, idx);
      }
    });
    return out;
  };

  /**
   * get bool array from int
   * @param {*} val
   */
  const getBoolsFromInt = (val) => {
    const out = [false, false, false, false, false, false, false];
    let idx = 0;
    while (val > 0) {
      out[idx] = !!(val & 1);
      val = val >> 1;
      idx++;
    }

    return out;
  };

  /**
   * on change
   * @param {*} event
   */
  const change = (event) => {
    const idx = event.target.name;
    let val = event.target.checked;

    const out = values.splice(0);
    out[idx] = val;
    // console.log('🚀 ~ change ~ out:', out);
    onChange(name, getIntFromBools(out));
  };

  const values = getBoolsFromInt(value);

  /**
   * get items
   * @returns
   */
  const getItemsEl = () => {
    return values.map((el, idx) => {
      return (
        <td key={idx}>
          <input type="checkbox" name={idx} checked={el} value={1} onChange={change} />
        </td>
      );
    });
  };

  const itemsEl = getItemsEl();

  return <>{itemsEl}</>;
};
